import type { CreateSignupCodeResponse } from 'contracts/api/v4/signup-codes/create-signup-code.service'

import type { SignupCodeStatus } from '../signup-codes/signup-codes.module.types'

import type { NormalisedCreateSignupCodeResponse } from './create-signup-code.module.types'

export const handleSuccess = (
  response: CreateSignupCodeResponse,
): NormalisedCreateSignupCodeResponse => ({
  code: response.code,
  organisation: response.organisation,
  startDate: new Date(response.created_on),
  status: response.status as SignupCodeStatus,
  timesUsed: response.times_used,
})
